import {css} from "@panda/css";

import {BrandCoinIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {OfferType} from "../../../../offer/types/OfferType";
import {getCurrency} from "../../../../utils/get_currency";
import {IUnlockChoicePrice} from "../../../types/IUnlockChoiceModalLayoutProps";
import {getUnlockChoicePropertyNoun} from "../../../utils/get_unlock_choice_property_noun";

interface IProps {
    price: IUnlockChoicePrice;
    offerType: OfferType | null;
}

export const UnlockChoiceModalPriceHeader = (props: IProps) => {
    const {price, offerType} = props;
    const currencyUnit = getCurrency({currency: price.currency});

    return (
        <div className={priceHeaderStyle}>
            <BrandCoinIcon width={72} height={72} />

            <div className={priceColumnStyle}>
                <Text as="p" variant="mini_header" color="var(--colors-secondary)" preserveFontSize>
                    Cena {getUnlockChoicePropertyNoun(offerType).genitive}
                </Text>
                <Text as="p" variant="headline_1" color="var(--colors-secondary)" className={priceValueStyle}>
                    <Highlight>{priceFormat(price.price, {unit: currencyUnit})}</Highlight>
                </Text>
                <Text as="p" variant="body_copy_2" color="var(--colors-gray-700)" className={priceM2Style}>
                    {priceM2Format(price.priceM2, {unit: currencyUnit})}
                </Text>
            </div>
        </div>
    );
};

const priceHeaderStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem"
});

const priceColumnStyle = css({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    minWidth: 0
});

const priceValueStyle = css({
    fontSize: "2.737rem",
    lineHeight: "3.6rem"
});

const priceM2Style = css({
    fontSize: "1.2rem",
    lineHeight: "1.8rem"
});
import {css} from "@panda/css";

import {BrandCoinIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {OfferType} from "../../../../offer/types/OfferType";
import {getCurrency} from "../../../../utils/get_currency";
import {IUnlockChoicePrice} from "../../../types/IUnlockChoiceModalLayoutProps";
import {getUnlockChoicePropertyNoun} from "../../../utils/get_unlock_choice_property_noun";

interface IProps {
    price: IUnlockChoicePrice;
    offerType: OfferType | null;
}

export const UnlockChoiceModalPriceHeader = (props: IProps) => {
    const {price, offerType} = props;
    const currencyUnit = getCurrency({currency: price.currency});

    return (
        <div className={priceHeaderStyle}>
            <BrandCoinIcon width={72} height={72} />

            <div className={priceColumnStyle}>
                <Text as="p" variant="mini_header" color="var(--colors-secondary)" preserveFontSize>
                    Cena {getUnlockChoicePropertyNoun(offerType).genitive}
                </Text>
                <Text as="p" variant="headline_1" color="var(--colors-secondary)" className={priceValueStyle}>
                    <Highlight>{priceFormat(price.price, {unit: currencyUnit})}</Highlight>
                </Text>
                <Text as="p" variant="body_copy_2" color="var(--colors-gray-700)" className={priceM2Style}>
                    {priceM2Format(price.priceM2, {unit: currencyUnit})}
                </Text>
            </div>
        </div>
    );
};

const priceHeaderStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem"
});

const priceColumnStyle = css({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    minWidth: 0
});

const priceValueStyle = css({
    fontSize: "2.737rem",
    lineHeight: "3.6rem"
});

const priceM2Style = css({
    fontSize: "1.2rem",
    lineHeight: "1.8rem"
});
